export default __webpack_public_path__ + "static/media/drainlife.8689872f.png";